import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" View ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_delete = _resolveComponent("delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ImageViewDialog = _resolveComponent("ImageViewDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.state.order.items,
      lazy: _ctx.isLoading,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "sku",
          label: "SKU"
        }),
        _createVNode(_component_el_table_column, {
          prop: "shopifyId",
          label: "Catalog"
        }),
        _createVNode(_component_el_table_column, {
          prop: "catalogCode",
          label: "Variant Code"
        }),
        _createVNode(_component_el_table_column, {
          prop: "quantity",
          label: "Quantity"
        }),
        _createVNode(_component_el_table_column, {
          prop: "artwork1",
          label: "Design"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              onClick: ($event: any) => (_ctx.Preview(scope.row.artwork1)),
              size: "small",
              type: "text",
              style: {"padding-right":"5px"}
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "Operations"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handleEdit(scope.row)),
              disabled: _ctx.state.order.status !== 'Unfulfilled' &&
            _ctx.state.isSubmited === _ctx.OrderDataService.ACTION.UPDATE
            
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Edit)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              size: "small",
              type: "danger",
              onClick: ($event: any) => (_ctx.handleDelete(scope.row)),
              disabled: _ctx.state.order.status !== 'Unfulfilled' &&
            _ctx.state.isSubmited === _ctx.OrderDataService.ACTION.UPDATE
            
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_delete)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "lazy"]), [
      [_directive_loading, _ctx.isLoading]
    ]),
    _createVNode(_component_ImageViewDialog, { ref: "imageViewDialog" }, null, 512)
  ]))
}